import { Stack, chakra } from "@chakra-ui/react"

// Post List

export const PostListMeta = chakra(Stack)

export const PostLiContent = chakra(Stack)

